import { NSARouterMakerResult } from "namirasoft-account-react";
import { ChatRow, RunRow } from "namirasoft-expert";
import { Component } from "react";
import { ExpertRouterProps } from "../ExpertRouterProps";
import { ChatPageInner } from "../pages/ChatPage";
import RunTest from "./RunTest";

interface ChatTestProps extends NSARouterMakerResult, ExpertRouterProps
{
    agent_id: string;
    runs: RunRow[];
    onRunChanged?: (run: RunRow) => void;
    onChatChanged?: (chat: ChatRow) => void;
}

interface ChatTestState
{
    runs: RunRow[];
}

class ChatTest extends Component<ChatTestProps, ChatTestState>
{
    constructor(props: ChatTestProps)
    {
        super(props);
        this.state = { runs: ChatPageInner.sortRuns(props.runs) };
    }

    override render()
    {
        return (
            <>
                {
                    this.state.runs.map((run) => (
                        <RunTest
                            key={run.id}
                            {...this.props}
                            run={run}
                            onRunChanged={run =>
                            {
                                this.setState({ runs: this.state.runs.map(r => r.id === run.id ? run : r) });
                                this.props.onRunChanged?.(run);
                            }}
                            onChatChanged={chat => this.props.onChatChanged?.(chat)}
                        />
                    ))
                }
            </>
        );
    }
}

export default ChatTest;